
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { message, Collapse, Button } from 'antd';
import { RiUserSettingsLine } from 'react-icons/ri';
import { IoIosTimer } from 'react-icons/io';
import { AiOutlineFileSearch, AiOutlineFire } from 'react-icons/ai';
import { CampaignGetSingle } from '../../apis/Influencer/Campaigns/CampaignGetSingle';
import { useGlobalState } from '../../store/state';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import './InfluencerCampaignDetailsPage.styles.scss';
import CampaignProgressComponent from '../../components/Influencers/Campaign/Details/CampaignProgressComponent';
import CampaignCreativeCollectionForm from '../../components/Influencers/Campaign/Creatives/CampaignCreativeCollectionForm';
import CampaignCreativeReviewCollectionForm from '../../components/Influencers/Campaign/Creatives/CampaignCreativeReviewCollectionForm';
import { RaiseCampaignInvoice } from '../../apis/Influencer/Campaigns/RaiseCampaignInvoice';

const { Panel } = Collapse;
const InfluencerCampaignCreativeViewPage = () => {
  const history = useHistory();
  const params = useParams();
  const [user] = useGlobalState('user');
  // const [raisedInvoice,setRaisedInvoice] = useState(false);
  const [camp, setCamp] = useState({});
  const getCampaignDetails = () =>{
    CampaignGetSingle(
      user.accessToken,
      params.campaignId,
    ).then(({ status, response })=>{
      console.log('API: res-> campaign single ==>', response);
      if (status === 200) {
        setCamp({
          ...response,
        });
        const _base = `/influencer/campaigns/${params.campaignId}`;
        if (response.connectionStatus === 'accepted') {
          history.push(`${_base}/creatives`); // redirect to review posts
        } else if (response.connectionStatus === 'assigned') {
          message.info('Please accept campaign first');
          history.push(_base); // redirtect to details of campaign
        } else {}
      } else {
        message.error('There is some error in getting Campaign list');
      }
    });
  };
  useEffect(() =>{ // load all list first time
    getCampaignDetails();
  }, []);

  const RaiseInvoice = () =>{
    RaiseCampaignInvoice(user.accessToken, {
      campaignid: params.campaignId,
    }).then(({ status, response })=>{
      console.log('raise response', response);
      if (status === 200) {
        message.success( response.msg || 'Successfully Raised Invoice for the Campaign!');
        getCampaignDetails();
        // setRaisedInvoice(camp.invoiceRequest)
      } else {
        message.error('There is some issue while raise invoice');
      }
    });
  };

  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6">
            <p className="m-0"><strong>Review Creatives</strong></p>
          </div>
          <div className="col-md-6 text-right">
            {camp.campaignAcceptedType === 'closed' ?
              <Button disabled={camp.invoiceRequest}
                className="common_button small"
                onClick={RaiseInvoice}>Raise Invoice</Button>:
              null
            }
            {/* <Button
                            className="common_button outlined py-1"
                            title="Submit your campaigns"
                            htmlType="submit"
                            onClick={creativesSubmission}
                        >Submit All Creatives</Button> */}
          </div>
        </div>
      </InfluencerTopSubHeaderComponent>
      <div style={{ padding: 15 }}>
        <div className="campaign_details pt-1">
          <div className="row">
            <div className="col-md-8 pr-2">
              {/* <h5>Creatives View Page</h5>
                            <p>Campaign Creatives Review Submission and submitted Overview will come here</p> */}
              {camp.campaignInfo?
                <CampaignCreativeReviewCollectionForm campId={params.campaignId}
                  campStatus={camp.campaignInfo.campaignstatus}
                  getCampaignDetails={getCampaignDetails}
                  platform={camp.campaignInfo.platform}/>:
                null
              }
            </div>
            <div className="col-md-4 pl-2">
              {
                camp.campaignInfo?
                  <CampaignProgressComponent
                    name={camp.campaignInfo.name}
                    startdate={camp.campaignInfo.startdate}
                    campId={camp.campaignInfo._id}
                  />:
                  <div>No Campaign Details present</div>
              }
            </div>
          </div>
        </div>
      </div>
    </InfluencerBaseLayoutComponent>
  );
};

export default InfluencerCampaignCreativeViewPage;
